/**
 * Locale-aware date formatting for tenant public sites — one place for the
 * mn-MN / en-AU mapping so news cards, articles and feeds stay consistent.
 */
export function useSiteDate() {
  const { locale } = useI18n()

  const intlLocale = computed(() => (locale.value === 'mn' ? 'mn-MN' : 'en-AU'))

  const short = (iso: string | null | undefined) => iso
    ? new Date(iso).toLocaleDateString(intlLocale.value, { day: 'numeric', month: 'short', year: 'numeric' })
    : ''

  const long = (iso: string | null | undefined) => iso
    ? new Date(iso).toLocaleDateString(intlLocale.value, { day: 'numeric', month: 'long', year: 'numeric' })
    : ''

  /** Compact "2 JUL" style used by the news feed block. */
  const dayMonth = (iso: string | null | undefined) => iso
    ? new Date(iso).toLocaleDateString(intlLocale.value, { day: 'numeric', month: 'short' }).toUpperCase()
    : ''

  return { short, long, dayMonth }
}
